import React, { useState } from 'react';
import RootWorkplaceSettingsModal from './RootWorkplaceSettingsModal';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import useScope from '../../../Scope/Hooks/useScope';

interface Props {
	rootWorkplaceId: string;
}

const RootWorkplaceSettingsButton: React.FC<Props> = ({ rootWorkplaceId }) => {
	const [isSettingsOpen, setIsSettingsOpen] = useState(false);
	const { isSlovakia } = useScope();

	if (!isSlovakia) {
		return <></>;
	}

	return (
		<>
			<Button
				title='component.rootWorkplaceSettings.button'
				theme={Theme.BLUE}
				onClick={() => setIsSettingsOpen(true)}
			/>
			<RootWorkplaceSettingsModal
				isOpen={isSettingsOpen}
				onClose={() => setIsSettingsOpen(false)}
				rootWorkplaceId={rootWorkplaceId}
			/>
		</>
	);
};

export default RootWorkplaceSettingsButton;
